<template>
	<div>
		<b-card title="绝技" no-body>
			<b-card-header header-tag="nav">
				<b-nav card-header tabs>
					<!-- <b-nav-item to="/wonder/yjj/p" exact exact-active-class="active">人气</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/yjj/j" exact exact-active-class="active">精选</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/yjj/g" exact exact-active-class="active">概念</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/yjj/i" exact exact-active-class="active">行业</b-nav-item> -->
					<b-nav-item to="/wonder/yjj/ml" exact exact-active-class="active">题材轮动</b-nav-item>
					<b-nav-item v-if="userRoles.includes('admin')" to="/wonder/opportunity/mining" exact exact-active-class="active">机会挖掘</b-nav-item>
					<b-nav-item to="/wonder/topic/table" :active="$route.path.startsWith('/wonder/topic/table') || $route.path.startsWith('/wonder/topic/detail')" exact-active-class="active">题材表格</b-nav-item>
					<b-nav-item to="/wonder/ai-report/morning" :active="$route.path.startsWith('/wonder/ai-report/')" exact-active-class="active">每日盘前(AI)</b-nav-item>
					<!-- <b-nav-item to="/wonder/uplimit/ladder" exact exact-active-class="active">涨停天梯</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/uplimit/promotion/daily" exact exact-active-class="active">天梯晋级</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/jyjy" exact exact-active-class="active">九阳神功</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/98" exact exact-active-class="active">98</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/99" exact exact-active-class="active">99</b-nav-item> -->
				</b-nav>
			</b-card-header>
			<b-card-body class="p-1 p-md-1">
				<router-view></router-view>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>	
	export default {
		data() {
			return {
				userRoles: []
			}
		},
		components: {
			
		},
		created() {
			this.updateUserRoles()
		},
		methods: {
			updateUserRoles() {
				try {
					const raw = localStorage.getItem('user_info')
					if (!raw) {
						this.userRoles = []
						return
					}
					const u = JSON.parse(raw)
					const r = u && u.roles
					this.userRoles = Array.isArray(r) ? r : String(r || '').split(',').map(s => s.trim()).filter(Boolean)
				} catch (e) {
					this.userRoles = []
				}
			}
		}
	}
</script>

<style scoped>
.card-header {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
}
.nav-tabs {
    flex-wrap: nowrap !important;
}
.nav-link {
    padding: 0.5rem 0.75rem;
    white-space: nowrap;
}
@media (max-width: 768px) {
    .nav-link {
        padding: 0.4rem 0.5rem;
        font-size: 0.9rem;
    }
}
</style>
